(function () {
  app.controller('StoreCtrl', [
    "$scope", '$timeout',
    function ($scope, $timeout) {

      $scope.is_open_sport = false;
      $scope.is_open_sort_by = false;
      $scope.filter_list = [
        {name: 'All', title: 'All Wax', sport_type: null, box_type: null},
        {name: '📦 Wax Cases', title: 'All Wax Boxes', sport_type: null, box_type: 'box'},
        {name: '📦 Wax Boxes', title: 'All Wax Boxes', sport_type: null, box_type: 'case'},
        {name: '⚾ Baseball', title: 'All Baseball', sport_type: 'baseball', box_type: null},
        {name: '🏀 Basketball', title: 'All Basketball', sport_type: 'basketball', box_type: null},
        {name: '🏈 Football', title: 'All Football', sport_type: 'football', box_type: null},
        {name: '🏒 Hockey', title: 'All Hockey', sport_type: 'hockey', box_type: null},
        {name: '⚽ Soccer', title: 'All Soccer', sport_type: 'soccer', box_type: null},
        {name: '🤼 MMA', title: 'All MMA', sport_type: 'mixed-martial-arts', box_type: null},
        {name: '🤼 Wrestling', title: 'All Wrestling', sport_type: 'wrestling', box_type: null},
        {name: '🏁 Motorsport', title: 'All Motorsport', sport_type: 'motorsports', box_type: null},
        {name: '🐙 Pokemon', title: 'All Pokemon', sport_type: null, box_type: 'pokemon'},
        {name: '💯 Non-sport', title: 'All Non-sport', sport_type: 'non-sport', box_type: null}
      ];

      $scope.filter_sort_list = [
        {title: 'Best Selling', value: 'best_selling'},
        {title: 'Featured', value: 'featured'},
        {title: 'Alphabetically, A-Z', value: 'alphabetically_az'},
        {title: 'Alphabetically, Z-A', value: 'alphabetically_za'},
        {title: 'Lowest Price + Shipping', value: 'lowest_price'},
        {title: 'Highest Price + Shipping', value: 'highest_price'}
      ]

      $scope.product_statuses = [
        { label: 'Mapped', value: "mapped" },
        { label: 'Needs Mapping', value: "needs_mapping" },
        { label: 'Needs Review', value: "needs_review" },
        { label: 'Not Sealed', value: "not_sealed" }
      ];

      $scope.selected_product_statuses = ["needs_mapping", "needs_review"];

      // A new status set starts again from the first page. The Store Manager select2 handler
      // (store_management.html.erb) resets the cursor itself before calling this; the admin
      // selector below relies on this reset.
      $scope.onProductStatusChange = function() {
        if (bulkBusy()) return;
        $scope.cursor = null;
        $scope.direction = 'next';
        $scope.getDataMapping($scope.key_search);
      };

      // Admin /review-boxes mapping view (review_boxes.html.erb): one single-choice select picks
      // the whole status set sent to data_mapping. The first choice is the set that page has
      // always opened with.
      $scope.mapping_status_choices = [
        { label: 'Needs Mapping + Needs Review', statuses: ['needs_mapping', 'needs_review'] },
        { label: 'Needs Mapping', statuses: ['needs_mapping'] },
        { label: 'Needs Review', statuses: ['needs_review'] },
        { label: 'Mapped', statuses: ['mapped'] },
        { label: 'Not Sealed', statuses: ['not_sealed'] }
      ];
      $scope.mapping_status_choice = $scope.mapping_status_choices[0];

      $scope.changeMappingStatusChoice = function () {
        if (bulkBusy()) return;
        $scope.selected_product_statuses = $scope.mapping_status_choice.statuses.slice();
        $scope.onProductStatusChange();
      };

      // ENG-403: while NOT_SEALED_CLASSIFY_ENABLED is off the server hides nothing in Product
      // Mapping, so neither status list above offers "Not Sealed" and no selection keeps it.
      // The page's applyData block sets not_sealed_enabled (a boolean) after this controller
      // exists, hence a watch; unset reads as off. On, both lists are the ones written above.
      // Nothing remembers a selection between visits (both pages start from the same two
      // statuses), so the clean-up of the selection below only guards the live scope.
      var ALL_PRODUCT_STATUSES = $scope.product_statuses;
      var ALL_MAPPING_STATUS_CHOICES = $scope.mapping_status_choices;

      function withoutNotSealed(list) {
        return list.filter(function (o) {
          return o.value != 'not_sealed' && !(o.statuses && o.statuses.indexOf('not_sealed') >= 0);
        });
      }

      $scope.$watch('not_sealed_enabled', function (on) {
        if (on === true) {
          $scope.product_statuses = ALL_PRODUCT_STATUSES;
          $scope.mapping_status_choices = ALL_MAPPING_STATUS_CHOICES;
          return;
        }
        $scope.product_statuses = withoutNotSealed(ALL_PRODUCT_STATUSES);
        $scope.mapping_status_choices = withoutNotSealed(ALL_MAPPING_STATUS_CHOICES);
        var kept = $scope.selected_product_statuses.filter(function (s) { return s != 'not_sealed'; });
        if (kept.length != $scope.selected_product_statuses.length) {
          if (kept.length == 0) {
            // Only "Not Sealed" was selected: back to the first choice, the set both pages open with.
            $scope.mapping_status_choice = $scope.mapping_status_choices[0];
            kept = $scope.mapping_status_choice.statuses.slice();
          }
          $scope.selected_product_statuses = kept;
        }
      });

      $scope.select_filter = $scope.filter_list[0];
      $scope.select_sort_by = $scope.filter_sort_list[0];
      $scope.sport = '';
      $scope.box_type = '';
      $scope.sort_by = '';
      $scope.page = 1;
      $scope.per_in_page = 12;
      $scope.is_more = false;
      $scope.is_loading = false;
      $scope.data_search = [];
      $scope.data = [];
      // The pager state of a listing that has not loaded (or failed to): no neighbours, no
      // cursors. A function, so a failed fresh load and a tab switch can return to exactly this.
      function emptyPageInfo() {
        return {
          hasNextPage: false,
          hasPreviousPage: false,
          startCursor: null,
          endCursor: null
        };
      }
      $scope.page_info = emptyPageInfo();
      $scope.cursor = null;
      $scope.direction = 'next';
      // data_mapping: how many Shopify products the last answer looked through (null until one arrives).
      $scope.scanned = null;
      $scope.page = 1;
      $scope.total_page = 0;
      $scope.inventory_sync = "N/A"
      $scope.connected_products = 0;
      $scope.sync_errors = 0;
      $scope.is_renew_connected_products = false;
      $scope.select_type_product = 'products';
      $scope.total_review_products = 0;

      $scope.data_sync_history = [];
      $scope.notification_number = { product_mapping_tab: 0 };

      // ENG-331 bulk approve / reject: client-side over the single-row endpoints.
      var BULK_CONCURRENCY = 3;
      // Must equal StoreProductApprovalService::MESSAGES[:already_mapped] (pinned by
      // spec/controllers/stores_approve_review_service_parity_spec.rb).
      var ALREADY_MAPPED_MESSAGE = 'This product has been mapped to another box.';
      // changed: rows bulk runs took out of the list since it was last loaded (reloadReviewPage).
      $scope.bulk = { running: false, action: null, total: 0, done: 0, cancelled: false, changed: 0 };
      $scope.in_stock = false;
      $scope.match_filter = 'all';

      $scope.init = function () {};

      $scope.changeType = function(filter) {
        if (filter.box_type && !filter.sport_type) {
          $scope.box_type = filter.box_type;
          $scope.sport_type = null;
          $scope.params_release_date = `?box_type=${$scope.box_type}`;
        }

        if (!filter.box_type && filter.sport_type) {
          $scope.box_type = null;
          $scope.sport_type = filter.sport_type;
          $scope.params_release_date = `?sport_type=${$scope.sport_type}`;
        }

        if (!filter.box_type && !filter.sport_type) {
          $scope.box_type = null;
          $scope.sport_type = null;
          $scope.params_release_date = '';
        }
        $scope.select_filter = filter;
        $scope.getData();
        $scope.close_menu('sport');
      }

      $scope.changeTypeSortBy = function(filter) {
        $scope.select_sort_by = filter;
        $scope.sort_by = filter.value;
        $scope.close_menu('sort_by');
        $scope.getData();
      }

      $scope.close_menu = function (type) {
        if (type == 'sort_by') {
          $scope.is_open_sort_by = false;
          $('#content-filter-by-sort-by').removeClass('show');
        } else {
          $scope.is_open_sport = false;
          $('#content-filter-by-sport').removeClass('show');
        }
      }

      $scope.click_filter = function (type) {
        if (type == 'sort_by') {
          $scope.is_open_sort_by = !$scope.is_open_sort_by;
          if ($scope.is_open_sort_by) {
            $scope.open_menu('sort_by');
          } else {
            $scope.close_menu('sort_by');
          }
        } else {
          $scope.is_open_sport = !$scope.is_open_sport;
          if ($scope.is_open_sport) {
            $scope.open_menu('sport');
          } else {
            $scope.close_menu('sport');
          }
        }
      }

      $scope.open_menu = function (type) {
        if (type == 'sort_by') {
          $scope.is_open_sort_by = true;
          $('#content-filter-by-sort-by').addClass('show');
        } else {
          $scope.is_open_sport = true;
          $('#content-filter-by-sport').addClass('show');
        }
      }
      
      $scope.getData = function (load_more = false) {
        $scope.is_loading = true;
        if (!load_more) {
          $scope.page = 1;
        } else {
          $scope.page += 1;
        }

        var data = { 
          page: $scope.page,
          per_page: $scope.per_in_page, 
          box_type: $scope.box_type,
          sport_type: $scope.sport_type,
          sort_by: $scope.sort_by
        }
        
        $.ajax({
          beforeSend: function(){
            $(".loading").hide();
            $(".loading").attr('style', 'background: rgba(0, 0, 0, 0)');
            $(".loading").attr('style', 'z-index: -1 !important');
          },
          url: $scope.data_store_url,
          dataType: "json",
          cache: false,
          type: "GET",
          data: data,
          afterSend: function(){},
          success: function (rs) {
            $timeout(function () {
              $scope.is_loading = false;
              if (rs.succeed) {
                $scope.is_more = rs.data.is_more;
                if (load_more) {
                  $scope.data = $scope.data.concat(rs.data.results);
                } else {
                  $scope.data = rs.data.results;
                }
              } else {
                $scope.data = [];
                $scope.is_more = false;
              }
            });
          }
        });
      }

      $scope.changeTab = function (tab) {
        if (bulkBusy()) return;
        // Whatever tab comes next, a mapping answer still in flight is not wanted there.
        abandonMappingRequest();
        $scope.data = [];
        // Orders and Product Mapping both write page_info (and mapping alone writes scanned), so
        // a tab would otherwise open on the pager of the one before it.
        $scope.page_info = emptyPageInfo();
        $scope.scanned = null;
        $scope.mapping_load_failed = false;
        $scope.page = 1;
        $scope.cursor = null;
        $scope.direction = 'next';
        $scope.current_tab = tab;
        
        switch (tab) {
          case "products":
            $scope.getDataProduct();
            break;

          case "orders":
            $scope.getDataOrder();
            break;

          case "product_mapping":
            $scope.getDataMapping();
            break;
        
          case "sync_history":
            $scope.getSyncHistoryData();
            $scope.current_tab = "sync_history";
            break;

          case "settings":
            $scope.current_tab = "settings";
            break;

          default:
            $scope.current_tab = "products";
            break;
        }
      }

      $scope.changePage = function (page) {
        if (bulkBusy()) return;
        // The buttons are disabled while loading too; a page fill can take seconds, and a second
        // click would repeat the same Shopify calls.
        if ($scope.is_loading) return;
        switch (page) {
          case "previous":
            $scope.cursor = $scope.page_info.startCursor;
            $scope.direction = 'previous';
            break;

          default:
            $scope.cursor = $scope.page_info.endCursor;
            $scope.direction = 'next';
            break;
        }
        
        $scope.getDataMapping($scope.key_search);
      }

      $scope.changePageOrder = function (page) {
        switch (page) {
          case "previous":
            $scope.cursor = $scope.page_info.startCursor;
            $scope.direction = 'previous';
            break;

          default:
            $scope.cursor = $scope.page_info.endCursor;
            $scope.direction = 'next';
            break;
        }
        
        $scope.getDataOrder($scope.key_search);
      }
      
      $scope.getSyncHistoryData = function () {
        $scope.is_loading = true;
        $.ajax({
          url: $scope.sync_history_url,
          dataType: "json",
          cache: false,
          type: "GET",
          data: { page: $scope.page },
          success: function (rs) {
            $timeout(function () {
              $scope.is_loading = false;
              if (rs.succeed) {
                $scope.data_sync_history = rs.data.sync_logs;
                $scope.total_page = rs.data.total_page;
              } else {
                toastr.error("An Unexpected Error Occurred!");
              }
            });
          },
        });
      }

      $scope.changePageSyncHistory = function (page) {
        if (page < 1) return;
        $scope.page = page;
        $scope.getSyncHistoryData();
      }

      // A new search starts again from the first page: the cursor in hand belongs to the old
      // query. Paging (changePage) keeps the cursor and calls getDataMapping directly.
      $scope.searchMapping = function (key_search) {
        if (bulkBusy()) return;
        // The same query is already on its way: a second request would repeat the same Shopify
        // reads. A changed query goes through, and getDataMapping drops the older answer. The
        // comparison is with the query of the request in flight, not with $scope.key_search: on
        // /review-boxes the search input is bound to key_search itself, so by the time
        // searchBoxes calls here it already holds the new text.
        if ($scope.is_loading && mappingQueryInFlight !== null && mappingQuery(key_search) === mappingQueryInFlight) return;
        $scope.cursor = null;
        $scope.direction = 'next';
        $scope.getDataMapping(key_search);
      };

      // The server fills a page from several Shopify pages, so an answer can be empty while
      // more pages follow. The pager must stay on such a page, or the merchant is stranded.
      $scope.hasMappingPages = function () {
        var info = $scope.page_info;
        return !!(info && (info.hasNextPage || info.hasPreviousPage));
      };

      $scope.showMappingPager = function () {
        return !!($scope.data && $scope.data.length > 0) || $scope.hasMappingPages();
      };

      // The empty-page text names only the pager buttons that can be used: Next is disabled on
      // the first answer of a long catalogue, Previous at its end.
      $scope.mappingPagerHint = function () {
        var info = $scope.page_info || {};
        if (info.hasNextPage && info.hasPreviousPage) return 'Use Next or Previous';
        if (info.hasNextPage) return 'Use Next';
        if (info.hasPreviousPage) return 'Use Previous';
        return '';
      };

      // Filling a page takes seconds, so a filter change can overlap a request still in flight:
      // only the newest answer is applied.
      var mappingRequestSeq = 0;
      // The query of the data_mapping request in flight (null when none), for searchMapping.
      var mappingQueryInFlight = null;

      function mappingQuery(key_search) {
        return key_search == null ? '' : String(key_search);
      }

      // Leaving the mapping view (a tab or type switch): its answer, if still on the way, must
      // not land on the next view, and it is the answer that would have cleared is_loading. The
      // loader that runs next sets is_loading again.
      function abandonMappingRequest() {
        mappingRequestSeq++;
        mappingQueryInFlight = null;
        $scope.is_loading = false;
      }

      // A fresh listing (no cursor sent: a filter, status, search or tab change) that failed has
      // no answer, and what is on screen belongs to another filter: its rows, its pager and its
      // "checked" count. Left there, an enabled Next would send that listing's end cursor with
      // the new filter and skip its first pages. Back to the state of a listing not yet loaded.
      // mapping_load_failed tells the empty row to say the listing could not be loaded rather than
      // that no product matches: the failed read said nothing about the catalogue.
      function clearMappingListing() {
        $scope.data = [];
        $scope.page_info = emptyPageInfo();
        $scope.scanned = null;
        $scope.mapping_load_failed = true;
      }

      $scope.getDataMapping = function (key_search = null) {
        if (bulkBusy()) return;
        $scope.clearBulkSelection();
        $scope.bulk.changed = 0;
        $scope.key_search = key_search;
        var seq = ++mappingRequestSeq;
        mappingQueryInFlight = mappingQuery(key_search);
        if ($scope.selected_product_statuses.length == 0 || $scope.selected_product_statuses.length == $scope.product_statuses.length) {
          // this case will get all
          selected_status = null;
        } else {
          selected_status =  $scope.selected_product_statuses;
        }

        let params = {
          q: $scope.key_search,
          is_admin: $scope.is_admin,
          product_statuses: selected_status,
          store_slug: $scope.store_slug,
          product_shopify_status: $scope.select_product_shopify_status
        }
        
        if ($scope.cursor) params.cursor = $scope.cursor;
        if ($scope.direction) params.direction = $scope.direction;
        // Decided now, from what is being sent: a request without a cursor starts a listing, one
        // with a cursor moves a page of the listing already on screen.
        var fresh = !params.cursor;
        $scope.mapping_load_failed = false;
        $scope.is_loading = true;
        $.ajax({
          // beforeSend: function(){
          //   $(".loading").hide();
          //   $(".loading").attr('style', 'background: rgba(0, 0, 0, 0)');
          //   $(".loading").attr('style', 'z-index: -1 !important');
          // },
          url: $scope.data_mapping_url,
          dataType: "json",
          cache: false,
          type: "GET",
          data: params,
          success: function (rs) {
            $timeout(function () {
              if (seq != mappingRequestSeq) return;
              mappingQueryInFlight = null;
              $scope.is_loading = false;
              if (rs.succeed) {
                $scope.data = rs.data.products;

                $scope.page_info = rs.data.page_info;
                $scope.is_renew = rs.data.is_renew;
                // Shopify products looked through for this answer (an older server omits it).
                $scope.scanned = typeof rs.data.scanned == 'number' ? rs.data.scanned : null;
              } else {
                // succeed: false (Shopify did not answer, or the request failed). A page move
                // (cursor sent) keeps data, cursor and page_info as they were, so Next /
                // Previous retry the same page. A fresh load has no page to retry: its rows and
                // pager are another listing's, so they are cleared. The toast carries the
                // server's own sentence (data_mapping answers every succeed: false with a fixed
                // one, e.g. "Shopify did not answer..."); the generic text is for an answer
                // that has none. escapeHtml: toastr renders its message as HTML by default.
                if (fresh) clearMappingListing();
                toastr.error(rs.message || "An Unexpected Error Occurred!", '', { escapeHtml: true });
              }
              tooltipsInit();
            });
          },
          // No JSON answer at all (network drop, 502 / 503, H12, an HTML page). Without this the
          // request would leave is_loading set, and the pager gate on is_loading would keep
          // Next / Previous disabled for good. As for succeed: false above: a page move keeps
          // data, cursor and page_info, so a second click retries the same page; a fresh load
          // is cleared.
          error: function () {
            $timeout(function () {
              if (seq != mappingRequestSeq) return;
              mappingQueryInFlight = null;
              $scope.is_loading = false;
              if (fresh) clearMappingListing();
              toastr.error('No response from the server. Please try again.');
            });
          },
        });
      }

      $scope.getDataOrder = function (key_search = null) {
        $scope.key_search = key_search;
        let params = {
          q: $scope.key_search
        }
        
        if ($scope.cursor) params.cursor = $scope.cursor;
        if ($scope.direction) params.direction = $scope.direction;
        $scope.is_loading = true;
        $.ajax({
          // beforeSend: function(){
          //   $(".loading").hide();
          //   $(".loading").attr('style', 'background: rgba(0, 0, 0, 0)');
          //   $(".loading").attr('style', 'z-index: -1 !important');
          // },
          url: $scope.data_order_url,
          dataType: "json",
          cache: false,
          type: "GET",
          data: params,
          success: function (rs) {
            $timeout(function () {
              $scope.is_loading = false;
              if (rs.succeed) {
                $scope.data = rs.data.orders;
                $scope.page_info = rs.data.page_info;
              } else {
                toastr.error("An Unexpected Error Occurred!");
              }
            });
          },
        });
      }

      $scope.unMappingProduct = function(store_product_id) {
        if (confirm("Are you sure you want to unmap this box?")) {
          let params = {
            store_product_id: store_product_id,
            page: $scope.page
          }
          
          $scope.is_loading = true;
          $.ajax({
            url: $scope.unmapping_product_url,
            dataType: "json",
            cache: false,
            type: "POST",
            data: params,
            success: function (rs) {
              $timeout(function () {
                $scope.is_loading = false;
                if (rs.succeed) {
                  toastr.success(rs.message);
                  $scope.connected_products = rs.data.connected_products;
                  // The badge is total Shopify products minus connected ones, so it rises by the
                  // number of CONNECTED rows the unmap removed (removed_connected): 0 for a failed
                  // push row or a review row, which were never counted. A server that predates
                  // the key answers nothing, so fall back to the old +1 for that deploy window.
                  var removed = (rs.data && typeof rs.data.removed_connected === 'number') ? rs.data.removed_connected : 1;
                  $scope.notification_number.product_mapping_tab += removed;
                  // Reload through data_product so the list keeps this tab's type and filters
                  // (the unmap response carries no list). The last row of a page steps back one.
                  if ($scope.data.length == 1 && $scope.page > 1) $scope.page -= 1;
                  $scope.getDataProduct();
                } else {
                  toastr.error("An Unexpected Error Occurred!");
                }
              });
            },
          });
        }
      }

      // ENG-401: the store-scoped search (StoresController#search_mapping_boxes). It hides no box:
      // each one carries the listing of this store that holds it (b.held), read fresh on every
      // search, so a Reject / Unmap / Map shows on the next search without a reload. Debounced
      // answers can arrive out of order, so only the latest request's answer is kept.
      var suggestionsSeq = 0;
      $scope.getSuggestions = function (data) {
        var seq = ++suggestionsSeq;
        $.ajax({
          beforeSend: function(){
            $(".loading").hide();
            $(".loading").attr('style', 'background: rgba(0, 0, 0, 0)');
            $(".loading").attr('style', 'z-index: -1 !important');
          },
          url: $scope.search_mapping_boxes_url,
          dataType: "json",
          cache: false,
          type: "GET",
          // is_admin + store_slug name the review-boxes page's store (init_store); unset on the
          // Store Manager, where the merchant's own store is used.
          data: { q: data.key_search, is_admin: $scope.is_admin, store_slug: $scope.store_slug },
          success: function (rs) {
            $timeout(function () {
              if (seq != suggestionsSeq) return;
              if (rs.succeed) {
                // init_store answers an admin with no store named with an object, not a list.
                $scope.data_search = Array.isArray(rs.data) ? rs.data : [];
                $scope.data_search.forEach(d => {
                  d.hidden = false;
                });
              } else {
                toastr.error(rs.message || "An Unexpected Error Occurred!");
              }
            });
          },
        })
      }

      // The listing of this store that holds a search result's box, or null when none does or
      // when it is the row's own listing (mapping it again only updates that row).
      function heldBy(box, row) {
        var held = box && box.held;
        if (!held) return null;
        if (row && held.shopify_product_id && String(held.shopify_product_id) == String(row.id)) return null;
        return held;
      }

      // The line under a search result and under the picked box: who holds the box now.
      $scope.heldLabel = function (box, row) {
        var held = heldBy(box, row);
        if (!held) return '';
        if (held.kind == 'review') return 'Suggested for ' + held.title;
        if (held.kind == 'push_failed') return 'Held by a failed Create Waxlisting';
        if (held.kind == 'pushing') return 'Being listed through Create Waxlisting';
        return 'Mapped to ' + held.title + (held.status ? ' (' + held.status + ')' : '');
      }

      // The confirmation names the listing that loses the box: a reassign can unmap an ACTIVE
      // listing (another live listing of the same product), not only an archived one. Shopify IDs
      // tell the two apart, since a relisted product usually keeps the old title.
      function reassignPrompt(data, held) {
        var box = '"' + data.box_new.name + '"';
        var here = 'this listing, "' + data.title + '" (Shopify ID ' + data.id + ')';
        var there = 'your ' + (held.status ? held.status + ' ' : '') + 'listing "' + held.title + '"' +
                    (held.shopify_product_id ? ' (Shopify ID ' + held.shopify_product_id + ')' : '');
        if (held.kind == 'review') {
          return box + ' is suggested for ' + there + '.\n\nMap it to ' + here + ' instead?\nThat suggestion will be rejected.';
        }
        if (held.kind == 'push_failed') {
          return box + ' is held by a failed Create Waxlisting.\n\nMap it to ' + here + ' instead?\nThe failed Waxlisting will be removed.';
        }
        return box + ' is mapped to ' + there + '.\n\nReassign it to ' + here + '?\nThe ' + (held.status ? held.status + ' ' : '') + 'listing will no longer be mapped to this box.';
      }

      // The listing a reassign took the box from shows as unmapped, if it is on this page and
      // shows that box (a listing that also holds another box keeps showing it until reload).
      // Its tick, message and run state go with the box (the reset applyReviewSuccess does): as
      // an unmapped row it is bulk-selectable again, and a tick left from when it was a review
      // row would put it in the next "Mark not sealed" without anyone choosing it.
      function releaseRow(productId, boxId) {
        ($scope.data || []).forEach(function (row) {
          if (String(row.id) == String(productId) && row.box && row.box.id == boxId) {
            row.box = {};
            row.bulk_selected = false;
            row.bulk_error = null;
            row.bulk_state = null;
          }
        });
      }

      $scope.close_menu = function (data) {
        suggestionsSeq++; // a search still in flight must not refill a closed menu
        data.key_search = '';
        $scope.data_search = [];
        $(`#content-filter-${data.id}`).removeClass('show');
      }

      $scope.open_menu = function (data) {
        var menu = $(`#content-filter-${data.id}`);
        menu.addClass('show');
        placePicker(menu);
      }

      // The picker's menu is absolutely positioned inside the table's own scroll box
      // (.ws-store-table-wrap: max-height 70vh, overflow auto; .table-responsive on review-boxes).
      // Opened on a bottom row it ran past the box's bottom edge and the box scrolled down to
      // show it, which a 50-result list made obvious (ENG-401 QA on testing). So it opens upward
      // when it does not fit below and there is more room above, and its result list is capped
      // to the room on that side, so the menu stays inside the box. Runs right after .show, before
      // the browser paints, so the menu can be measured.
      var PICKER_RESULTS_MAX = 320; // .ws-store-picker-results' max-height in store_manager.scss
      var PICKER_RESULTS_MIN = 120;
      function placePicker(menu) {
        var dropdown = menu.closest('.dropdown');
        var results = menu.find('.ws-store-picker-results');
        if (!dropdown.length || !results.length) return;

        dropdown.removeClass('dropup');
        results.css('max-height', '');
        var toggle = dropdown[0].getBoundingClientRect();
        var box = visibleBox(dropdown[0]);
        var below = box.bottom - toggle.bottom;
        var above = toggle.top - box.top;
        // Everything in the menu but the result list (search field, paddings, the static
        // "Please enter…" line) plus the gap to the toggle.
        var fixed = menu.outerHeight() - results.outerHeight() + 8;
        var up = below < fixed + PICKER_RESULTS_MAX && above > below;
        dropdown.toggleClass('dropup', up);
        var room = (up ? above : below) - fixed;
        results.css('max-height', Math.max(PICKER_RESULTS_MIN, Math.min(PICKER_RESULTS_MAX, room)) + 'px');
      }

      // The part of the viewport that el's scrolling ancestors, and the sticky top nav, leave visible.
      function visibleBox(el) {
        var box = { top: 0, bottom: window.innerHeight };
        for (var p = el.parentElement; p && p !== document.body; p = p.parentElement) {
          var overflowY = getComputedStyle(p).overflowY;
          if (overflowY == 'auto' || overflowY == 'scroll' || overflowY == 'hidden') {
            var r = p.getBoundingClientRect();
            box.top = Math.max(box.top, r.top);
            box.bottom = Math.min(box.bottom, r.bottom);
          }
        }
        var nav = document.querySelector('.ws-nav');
        if (nav && /sticky|fixed/.test(getComputedStyle(nav).position)) {
          box.top = Math.max(box.top, nav.getBoundingClientRect().bottom);
        }
        return box;
      }

      $scope.click_change = function (data) {
        var is_hide = $(`#content-filter-${data.id}`).hasClass('show');
        
        $('.dropdown-menu.dropdown-menu-right').removeClass('show');
        suggestionsSeq++; // nor another row's menu
        data.key_search = '';
        $scope.data_search = [];

        if (!is_hide) {
          $scope.open_menu(data);
        }
      }

      $scope.select_box = function(data, box) {
        data.box_new = {
          name: box.name,
          slug: box.slug,
          image: box.image,
          id: box.id,
          held: box.held
        };
        data.is_change = true;
        $scope.close_menu(data);
      }

      $scope.save_box = function(data) {
        if(!data || !data.is_change) return;

        // is_admin + store_slug: the review-boxes page maps into the store it names
        // (StoresController#mapping_store); both are unset on the Store Manager.
        var params = {
          box_slug: data.box_new.slug,
          store_slug: $scope.store_slug,
          is_admin: $scope.is_admin,
          product_id: data.id
        };
        // ENG-401: a box another listing holds moves here only once the person confirms which
        // listing loses it; reassign_from pins that holder, so the server refuses if it changed.
        var held = heldBy(data.box_new, data);
        if (held) {
          if (!held.reassignable) {
            toastr.error('This box is being listed on Shopify through Create Waxlisting. Try again once that finishes.');
            return;
          }
          if (!confirm(reassignPrompt(data, held))) return;
          params.reassign = true;
          params.reassign_from = held.store_product_id;
        }

        $.ajax({
          // beforeSend: function(){
            // $(".loading").hide();
            // $(".loading").attr('style', 'background: rgba(0, 0, 0, 0)');
            // $(".loading").attr('style', 'z-index: -1 !important');
          // },
          url: $scope.save_data_mapping_url,
          dataType: "json",
          cache: false,
          type: "POST",
          data: params,
          afterSend: function(){},
          success: function (rs) {
            $timeout(function () {
              if (rs.succeed) {
                data.is_change = false;
                data.box = data.box_new;
                // Mapped now, so no longer bulk-selectable: drop the tick and message it had as an
                // unmapped or review row instead of carrying them along unseen (as applyReviewSuccess does).
                data.bulk_selected = false;
                data.bulk_error = null;
                data_box_new = {};
                // Only a new mapping row moves the counters (an update of an existing row moves
                // neither), net of the CONNECTED row a reassign took away (removed_connected 0
                // or 1). The badge is total Shopify products minus connected ones, so it
                // drops by what the KPI gains. Unclamped, like unMappingProduct's
                // removed_connected add: a guard on one side only lets map/unmap pairs drift it
                // away from the server.
                var removed = (rs.data && typeof rs.data.removed_connected === 'number') ? rs.data.removed_connected : 0;
                var gained = (rs.data && rs.data.created ? 1 : 0) - removed;
                $scope.connected_products += gained;
                $scope.notification_number.product_mapping_tab -= gained;
                if (rs.data && rs.data.released_product_id) releaseRow(rs.data.released_product_id, data.box.id);
                toastr.success(rs.message);
              } else {
                toastr.error(rs.message);
              }
            });
          }
        });
      }

      $scope.getDataProduct = function (key_search = null) {
        if (bulkBusy()) return;
        $scope.clearBulkSelection();
        $scope.bulk.changed = 0;

        if (key_search != null) {
          $scope.key_search = key_search;
        }

        // Filter keys are added only when set, so the merchant Products-tab request is unchanged.
        var params = { page: $scope.page, type: $scope.select_type_product, is_admin: $scope.is_admin, store_slug: $scope.store_slug, q: $scope.key_search, status: $scope.select_status };
        if ($scope.in_stock) params.in_stock = 1;
        if ($scope.match_filter && $scope.match_filter != 'all') params.match = $scope.match_filter;

        $scope.is_loading = true;
        $.ajax({
          // beforeSend: function(){
          //   $(".loading").hide();
          //   $(".loading").attr('style', 'background: rgba(0, 0, 0, 0)');
          //   $(".loading").attr('style', 'z-index: -1 !important');
          // },
          url: $scope.data_product_url,
          dataType: "json",
          cache: false,
          type: "GET",
          data: params,
          success: function (rs) {
            $timeout(function () {
              $scope.is_loading = false;
              if (rs.succeed) {
                $scope.data = rs.data.products;
                $scope.total_page = rs.data.total_page;
                $scope.is_renew_connected_products = rs.data.is_renew_connected_products;
                $scope.connected_products = rs.data.total_products;
                $scope.total_review_products = rs.data.total_review_products;
                inventory_sync();
                if ($scope.select_type_product == 'review') {
                  if ($scope.data.length == 0 && $scope.page > 1) {
                    $scope.changePageProductReview(1);
                  } else {
                    if ($scope.data.length > 0 && $scope.is_admin) {
                      $scope.dataTable();
                    }
                  }
                }
              } else {
                toastr.error("An Unexpected Error Occurred!");
              }
            });
          },
        });
      }

      $scope.changePageProduct = function (page) {
        if (bulkBusy()) return;
        if (page < 1) return;
        $scope.page = page;
        $scope.getDataProduct();
      }

      $scope.changePageProductReview = function (page) {
        if (bulkBusy()) return;
        if (page < 1) return;
        $scope.page = page;
        let url = new URL(location.href);
        url.searchParams.set('page', page);
        try {
          Turbolinks.visit(url.toString());
        } catch (error) {
          location.href = url.toString();
        }
      }

      $scope.syncProduct = function (product) {
        $.ajax({
          // beforeSend: function(){
          //   $(".loading").hide();
          //   $(".loading").attr('style', 'background: rgba(0, 0, 0, 0)');
          //   $(".loading").attr('style', 'z-index: -1 !important');
          // },
          url: $scope.sync_product_url,
          dataType: "json",
          cache: false,
          type: "POST",
          data: { product_id: product.id },
          success: function (rs) {
            $timeout(function () {
              if (rs.succeed) {
                product.inventory_quantity = rs.data.inventory_quantity;
                inventory_sync();
                toastr.success(rs.message);
              } else {
                toastr.error(rs.message);
              }
            });
          }
        });
      }

      function inventory_sync() {
        if ($scope.data.length > 0) {
          var products_need_sync = $scope.data.filter(function(item) {
            return item.shopify_inventory_quantity != item.inventory_quantity;
          });

          if (products_need_sync.length == $scope.data.length) {
            $scope.inventory_sync = '0%'
            return;
          }

          $scope.inventory_sync = products_need_sync.length == 0 ? '100%' : `${((products_need_sync.length / $scope.data.length) * 100).toFixed(2)}%`;
        }
      }

      $scope.changeTypeProduct = function(type) {
        // Not wired to a live control today (/review-boxes switches type with a form submit, a
        // full page load), but the type switch is where a mapping answer would otherwise land
        // on the review list.
        abandonMappingRequest();
        $scope.select_type_product = type;
        $scope.data = [];
        $scope.page = 1;
        $scope.getDataProduct();
      }

      $scope.changeStatusProduct = function(status) {
        if (bulkBusy()) return;
        $scope.select_status = status;
        $scope.data = [];
        $scope.page = 1;
        $scope.getDataProduct();
      }

      $scope.changeStatusProductMapping = function(status) {
        if (bulkBusy()) return;
        $scope.select_product_shopify_status = status;
        $scope.data = [];
        $scope.cursor = null;
        $scope.direction = 'next';

        $scope.getDataMapping($scope.key_search);
      }

      // Rows come in two shapes: the Product Mapping tab (and the admin "mapping" type)
      // carry the suggestion under d.box; the review list carries it on the row itself.
      function isMappingShape() {
        return $scope.current_tab == 'product_mapping' || $scope.select_type_product == 'mapping';
      }

      function applyReviewSuccess(kind, product) {
        var mapping = isMappingShape();
        // Settled, by a single click or a bulk run: drop any earlier run's tick and message,
        // or an Undo would bring the row back pre-ticked with a stale error, and the next
        // bulk run would include it unasked.
        product.bulk_selected = false;
        product.bulk_error = null;
        product.bulk_state = null;
        if (kind == 'approve') {
          if (mapping) {
            product.box.is_review = false;
          } else {
            product.is_review = false;
          }
          $scope.connected_products += 1;
          if ($scope.notification_number.product_mapping_tab > 0) {
            $scope.notification_number.product_mapping_tab -= 1;
          }
        } else if (mapping) {
          product.box = {};
        } else {
          product.is_review = false;
          product.is_rejected = true;
        }
      }

      // One row, one POST, shared by a single click and a bulk run. done(rs) always fires,
      // inside $timeout; an ajax error resolves as {succeed: false, network_error: true}
      // so a bulk run keeps going. A single click passes no done, so an ajax error stays
      // as silent as it always was.
      function sendReview(kind, product, opts, done) {
        opts = opts || {};
        $.ajax({
          url: kind == 'approve' ? $scope.approve_review_url : $scope.reject_review_url,
          dataType: "json",
          cache: false,
          type: "POST",
          // A bulk run shows its own progress; left global, every lane would flash the
          // layouts' full-screen ajaxSend overlay over it (fe.rules.md FE-1).
          global: !opts.silent,
          // is_admin + store_slug name the review-boxes page's store, so an admin acts on that
          // store's row (StoresController#review_row_scope). Unset on the Store Manager.
          data: { product_id: product.id, is_admin: $scope.is_admin, store_slug: $scope.store_slug },
          success: function (rs) {
            $timeout(function () {
              if (rs.succeed) {
                applyReviewSuccess(kind, product);
                if (!opts.silent) toastr.success(rs.message);
              } else if (!opts.silent) {
                toastr.error(rs.message);
              }
              if (done) done(rs);
            });
          },
          error: function () {
            $timeout(function () {
              if (done) done({ succeed: false, network_error: true, message: 'No response from the server. Reload to check this row.' });
            });
          }
        });
      }

      $scope.approveReview = function(product) {
        if (bulkBusy()) return;
        sendReview('approve', product);
      }

      $scope.rejectReview = function(product) {
        if (bulkBusy()) return;
        sendReview('reject', product);
      }

      // Bulk selection is a flag on the row object, so replacing $scope.data (reload, page,
      // filter or tab change) drops it with the rows.
      $scope.isPendingReview = function (d) {
        if (!d) return false;
        if (isMappingShape()) {
          return !!(d.box && d.box.name && d.box.is_review);
        }
        return !!(d.is_review && !d.is_rejected);
      };

      // ENG-402: a row with no box at all (the server's "Needs mapping") can carry a not-sealed
      // mark. Only the Store Manager Product Mapping tab sets not_sealed_url, so review_boxes
      // keeps selecting review rows only.
      $scope.isUnmapped = function (d) {
        return !!d && !(d.box && d.box.name);
      };

      function notSealedRowsEnabled() {
        return !!$scope.not_sealed_url && $scope.current_tab == 'product_mapping';
      }

      $scope.isBulkSelectable = function (d) {
        return $scope.isPendingReview(d) || (notSealedRowsEnabled() && $scope.isUnmapped(d));
      };

      $scope.bulkSelectableRows = function () {
        return ($scope.data || []).filter($scope.isBulkSelectable);
      };

      $scope.bulkSelectedRows = function () {
        return $scope.bulkSelectableRows().filter(function (d) { return d.bulk_selected; });
      };

      $scope.bulkSelectedCount = function () {
        return $scope.bulkSelectedRows().length;
      };

      // Approve / Reject act on the selected review rows only; an unmapped row ticked for a
      // not-sealed bulk action is in bulkSelectedRows but is never sent to the review endpoints.
      $scope.bulkSelectedReviewRows = function () {
        return $scope.bulkSelectedRows().filter($scope.isPendingReview);
      };

      $scope.bulkSelectedReviewCount = function () {
        return $scope.bulkSelectedReviewRows().length;
      };

      // A row with a single not-sealed request in flight is excluded from both subsets
      // (bulk_state 'running'), so one row never has two requests racing.
      $scope.bulkMarkableRows = function () {
        if (!notSealedRowsEnabled()) return [];
        return $scope.bulkSelectedRows().filter(function (d) {
          return $scope.isUnmapped(d) && !$scope.isNotSealedHidden(d) && d.bulk_state != 'running';
        });
      };

      $scope.bulkRestorableRows = function () {
        if (!notSealedRowsEnabled()) return [];
        return $scope.bulkSelectedRows().filter(function (d) {
          return $scope.isUnmapped(d) && $scope.isNotSealedHidden(d) && d.bulk_state != 'running';
        });
      };

      $scope.bulkAllSelected = function () {
        var rows = $scope.bulkSelectableRows();
        return rows.length > 0 && rows.every(function (d) { return d.bulk_selected; });
      };

      $scope.bulkSomeSelected = function () {
        var count = $scope.bulkSelectedCount();
        return count > 0 && count < $scope.bulkSelectableRows().length;
      };

      $scope.toggleBulkSelectAll = function () {
        if ($scope.bulk.running || $scope.is_loading) return;
        var select = !$scope.bulkAllSelected();
        $scope.bulkSelectableRows().forEach(function (d) { d.bulk_selected = select; });
      };

      $scope.clearBulkSelection = function () {
        if ($scope.bulk.running) return;
        ($scope.data || []).forEach(function (d) {
          d.bulk_selected = false;
          d.bulk_error = null;
        });
      };

      // Explicit method -> badge map, never a prefix test: a 'upc_*' method is not always a
      // barcode pick (the ENG-322 box-match branch adds 'upc_conflict', ranked by name), so an
      // unlisted method gets no badge. Keep these keys identical to the "match type" filter
      // allow-list in StoresController (REVIEW_MATCH_METHODS, read by data_product), so the
      // badge and the filter agree on what "Barcode" and "Name" cover.
      var MATCH_METHOD_LABELS = {
        upc_unique: 'Barcode',
        upc_ambiguous: 'Barcode',
        upc_unverified: 'Barcode',
        name: 'Name'
      };

      $scope.matchMethodLabel = function (d) {
        var method = d && d.data && d.data.match_method;
        if (typeof method != 'string') return null;
        // Own keys only, so a method named like an Object.prototype member never returns a function.
        if (!Object.prototype.hasOwnProperty.call(MATCH_METHOD_LABELS, method)) return null;
        return MATCH_METHOD_LABELS[method];
      };

      $scope.runBulkReview = function (kind) {
        // Not while a reload is in flight: its response replaces $scope.data, and the run would
        // keep updating rows that are no longer in the table. The bar and the checkboxes are
        // disabled on is_loading for the same reason.
        if ($scope.bulk.running || $scope.is_loading) return;
        var rows = $scope.bulkSelectedReviewRows();
        if (rows.length == 0) return;
        var noun = rows.length == 1 ? 'suggestion' : 'suggestions';
        var question = kind == 'approve'
          ? 'Approve ' + rows.length + ' selected ' + noun + '? Each one goes live as a mapping (price and stock shown to buyers).'
          : 'Reject ' + rows.length + ' selected ' + noun + '?';
        if (!confirm(question)) return;

        var queue = rows.slice();
        var active = 0;
        var summary = { approved: 0, rejected: 0, already_mapped: 0, failed: 0 };
        // Mutate, never replace: the row and bar templates read bulk through child scopes.
        angular.extend($scope.bulk, { running: true, action: kind, total: rows.length, done: 0, cancelled: false });
        rows.forEach(function (d) {
          d.bulk_state = 'queued';
          d.bulk_error = null;
        });
        bindBulkLeaveGuards();

        function next() {
          if ($scope.bulk.cancelled) queue = [];
          if (queue.length == 0) {
            if (active == 0) finish();
            return;
          }
          // Each approval recounts stores.data['connected_products'] inside its own
          // transaction, so approvals in flight together can store a count that misses one
          // another. The final row waits until every other request has returned, so its
          // recount sees all of them. The lane that returns last sends it.
          if (kind == 'approve' && queue.length == 1 && active > 0) return;
          var row = queue.shift();
          active += 1;
          row.bulk_state = 'running';
          sendReview(kind, row, { silent: true }, function (rs) {
            active -= 1;
            $scope.bulk.done += 1;
            if (rs.succeed) {
              summary[kind == 'approve' ? 'approved' : 'rejected'] += 1;
              row.bulk_state = null;
              row.bulk_selected = false;
              row.bulk_moved = true;
              $scope.bulk.changed += 1;
            } else if (rs.message == ALREADY_MAPPED_MESSAGE) {
              // Stays selected with its message, so "Reject selected" can clear it next.
              summary.already_mapped += 1;
              row.bulk_state = 'already_mapped';
              row.bulk_error = rs.message;
            } else {
              summary.failed += 1;
              row.bulk_state = 'failed';
              row.bulk_error = rs.message || 'Request failed.';
            }
            next();
          });
        }

        function finish() {
          unbindBulkLeaveGuards();
          rows.forEach(function (d) {
            if (d.bulk_state == 'queued') d.bulk_state = null;
          });
          $scope.bulk.running = false;

          var skipped = $scope.bulk.total - $scope.bulk.done;
          var parts = [];
          if (summary.approved > 0) parts.push(summary.approved + ' approved');
          if (summary.rejected > 0) parts.push(summary.rejected + ' rejected');
          if (summary.already_mapped > 0) parts.push(summary.already_mapped + ' already mapped');
          if (summary.failed > 0) parts.push(summary.failed + ' failed');
          if ($scope.bulk.cancelled && skipped > 0) parts.push(skipped + ' not processed');
          var message = 'Bulk ' + kind + ' finished: ' + (parts.length > 0 ? parts.join(', ') : 'nothing processed') + '.';
          if (summary.already_mapped > 0 || summary.failed > 0 || skipped > 0) {
            toastr.warning(message);
          } else {
            toastr.success(message);
          }
        }

        var lanes = Math.min(BULK_CONCURRENCY, queue.length);
        for (var i = 0; i < lanes; i++) next();
      };

      // data_product pages the review list by offset, so each row a run approved or rejected
      // pulls a row from the next page up into this one. Loading the same page number again
      // shows those rows; paging first would skip them. User-triggered on purpose: a reload
      // drops the run's per-row messages and Undo buttons.
      $scope.reloadReviewPage = function () {
        if ($scope.is_loading) return;
        $scope.getDataProduct();
      };

      // ENG-402 "Not a sealed product" (Store Manager Product Mapping tab). The server hides a
      // listing no sealed box can map to from Needs mapping, and StoresController#update_not_sealed
      // marks / restores / confirms them. Each unmapped row carries d.not_sealed (null on a
      // mapped or in-review row): category, tier, rule, source, hidden, suggested, restored.
      // Rows stay in the list and update in place, like ENG-331's approve / reject; the next
      // load applies the filter.
      var NOT_SEALED_LABELS = {
        break: 'Break',
        single: 'Single',
        supply: 'Supply',
        other_non_sealed: 'Other non-sealed'
      };
      // The noun phrase after "Looks like": the labels above do not read after an article.
      var NOT_SEALED_HINTS = {
        break: 'a break',
        single: 'a single card',
        supply: 'a supply item',
        other_non_sealed: 'a non-sealed item'
      };
      var NOT_SEALED_ERRORS = {
        mapped: 'Mapped or in review — not changed.',
        no_suggestion: 'No suggestion to confirm any more.',
        title_changed: 'Title out of sync with Shopify — reload or try again in a few minutes.'
      };

      // Own keys only, so a server value named like an Object.prototype member never returns a function.
      function ownLabel(map, key) {
        if (typeof key != 'string' || !Object.prototype.hasOwnProperty.call(map, key)) return null;
        return map[key];
      }

      $scope.isNotSealedHidden = function (d) {
        return !!(d && d.not_sealed && d.not_sealed.hidden);
      };

      // A suggest-tier match: still in Needs mapping, with a hint and a one-click Confirm.
      $scope.isNotSealedSuggested = function (d) {
        return !!(d && d.not_sealed && d.not_sealed.suggested);
      };

      $scope.notSealedLabel = function (d) {
        return ownLabel(NOT_SEALED_LABELS, d && d.not_sealed && d.not_sealed.category) || 'Not sealed';
      };

      $scope.notSealedHint = function (d) {
        return 'Looks like ' + (ownLabel(NOT_SEALED_HINTS, d && d.not_sealed && d.not_sealed.category) || 'a non-sealed item');
      };

      // "<Category> · Rule <id>" for an automatic hide; "<Category> · Marked by you" for a
      // person's mark, or "Confirmed by you" when they confirmed a suggestion. actor names who
      // did it and defaults to "you"; the admin review-boxes page, which looks at another
      // merchant's store, passes 'the store'. Always a literal from the template, never row data.
      $scope.notSealedReason = function (d, actor) {
        var ns = d && d.not_sealed;
        if (!ns || !ns.hidden) return '';
        var label = $scope.notSealedLabel(d);
        if (ns.source == 'manual') {
          return label + ' · ' + (ns.tier == 'suggest' ? 'Confirmed' : 'Marked') + ' by ' + (actor || 'you');
        }
        return label + (ns.rule ? ' · Rule ' + ns.rule : '');
      };

      // rs.succeed false is a refusal of the whole request; otherwise every row has its own
      // outcome (ok, or a reason such as "mapped" for a listing that has a mapping after all).
      function applyNotSealedResponse(rs, rows) {
        if (!rs || !rs.succeed) {
          toastr.error((rs && rs.message) || 'An Unexpected Error Occurred!');
          return;
        }
        var byId = {};
        rows.forEach(function (d) { byId[String(d.id)] = d; });
        var okCount = 0;
        ((rs.data && rs.data.results) || []).forEach(function (result) {
          var row = byId[String(result.id)];
          if (!row) return;
          if (result.ok) {
            okCount += 1;
            row.not_sealed = result.not_sealed;
            row.bulk_selected = false;
            row.bulk_error = null;
          } else {
            row.bulk_error = ownLabel(NOT_SEALED_ERRORS, result.reason) || 'Not changed.';
            // A confirm with nothing left to confirm: the row still shows the suggestion hint
            // and a Confirm that would fail again on every click. The server answers with the
            // flag that holds now (a mark or restore made elsewhere, or a rules change that
            // dropped the suggestion), so the row takes it and the hint, Confirm, Restore and
            // bulk counts follow it -- null included, when no flag is left at all. Only for
            // no_suggestion: a title_changed flag comes from the mirror's title, not the title
            // this row shows, and for a mapped listing the row's box is not known here.
            if (result.reason == 'no_suggestion' && 'not_sealed' in result) row.not_sealed = result.not_sealed;
          }
        });
        if (okCount == rows.length) {
          toastr.success(rs.message);
        } else {
          toastr.warning(rs.message);
        }
      }

      // One POST for the whole batch (a single click sends one row). The server refuses more
      // than this many products in one request (NotSealed::ManualMarker::MAX_BATCH). A Product
      // Mapping page is one Shopify page (100 rows at most) plus what the page fill appended,
      // so "select all" can pass it: runBulkNotSealed sends those in sequential chunks.
      var NOT_SEALED_BATCH = 100;

      // True when the server changed at least one listing (data.changed). A refused request, or
      // one where every row was skipped, moved nothing, so the "Needs mapping" count is as it was.
      function notSealedChanged(rs) {
        return !!(rs && rs.succeed && rs.data && rs.data.changed > 0);
      }

      // The server badge is the source of truth: once phase 2 (ENG-403) subtracts
      // NotSealed::StoreCount, a mark, restore or confirm moves it on the server, and this page
      // only has to read it again (before that the re-read returns the same number). Store
      // Manager sets notification_number_url, /review-boxes does not.
      function refreshNotificationNumber() {
        if (!$scope.notification_number_url) return;
        $scope.fetchNotificationNumber({ silent: true });
      }

      // User-clicked, so it stays global and the layouts' overlay shows (fe.rules.md FE-1).
      // done(ok, changed) always fires, inside $timeout; ok is true when the server accepted
      // the request and changed is true when it changed at least one listing. A single click
      // passes no done, so it re-reads the count itself; a bulk run re-reads once, at its end.
      function sendNotSealed(op, rows, done) {
        rows.forEach(function (d) {
          d.bulk_state = 'running';
          d.bulk_error = null;
        });
        $.ajax({
          url: $scope.not_sealed_url,
          type: "POST",
          contentType: "application/json",
          dataType: "json",
          cache: false,
          data: JSON.stringify({
            op: op,
            products: rows.map(function (d) { return { id: d.id, title: d.title }; })
          }),
          success: function (rs) {
            $timeout(function () {
              rows.forEach(function (d) { d.bulk_state = null; });
              applyNotSealedResponse(rs, rows);
              var changed = notSealedChanged(rs);
              if (done) {
                done(!!(rs && rs.succeed), changed);
              } else if (changed) {
                refreshNotificationNumber();
              }
            });
          },
          error: function () {
            $timeout(function () {
              rows.forEach(function (d) { d.bulk_state = null; });
              toastr.error('No response from the server. Reload to check these rows.');
              if (done) done(false);
            });
          }
        });
      }

      function sendNotSealedOne(op, d) {
        if (bulkBusy()) return;
        if (d.bulk_state == 'running') return;
        sendNotSealed(op, [d]);
      }

      $scope.markNotSealed = function (d) { sendNotSealedOne('mark', d); };
      $scope.restoreNotSealed = function (d) { sendNotSealedOne('restore', d); };
      $scope.confirmNotSealed = function (d) { sendNotSealedOne('confirm', d); };

      // op: 'mark' (selected unmapped rows that are not hidden) or 'restore' (selected hidden rows).
      $scope.runBulkNotSealed = function (op) {
        if ($scope.bulk.running || $scope.is_loading) return;
        var rows = op == 'restore' ? $scope.bulkRestorableRows() : $scope.bulkMarkableRows();
        if (rows.length == 0) return;
        var noun = rows.length == 1 ? 'listing' : 'listings';
        var question = op == 'restore'
          ? 'Restore ' + rows.length + ' selected ' + noun + ' to Needs mapping?'
          : 'Mark ' + rows.length + ' selected ' + noun + ' as not sealed? They leave Needs mapping.';
        if (!confirm(question)) return;

        // Mutate, never replace: the row and bar templates read bulk through child scopes.
        // bulk.running makes bulkBusy() refuse every other action until the last POST returns.
        angular.extend($scope.bulk, { running: true, action: op, total: rows.length, done: 0, cancelled: false });
        var chunks = [];
        for (var i = 0; i < rows.length; i += NOT_SEALED_BATCH) chunks.push(rows.slice(i, i + NOT_SEALED_BATCH));

        // The count is re-read once, when the run ends, not after every chunk. A run that a
        // refused chunk stopped still re-reads if an earlier chunk changed anything.
        var anyChanged = false;
        function finishRun() {
          angular.extend($scope.bulk, { running: false });
          if (anyChanged) refreshNotificationNumber();
        }

        // A refused or failed chunk stops the run: the later rows stay ticked for a retry.
        function sendNextChunk() {
          if (chunks.length == 0) {
            finishRun();
            return;
          }
          var chunk = chunks.shift();
          sendNotSealed(op, chunk, function (ok, changed) {
            $scope.bulk.done += chunk.length;
            if (changed) anyChanged = true;
            if (ok) {
              sendNextChunk();
            } else {
              finishRun();
            }
          });
        }
        sendNextChunk();
      };

      function bulkBusy() {
        if (!$scope.bulk.running) return false;
        toastr.info('Please wait until the bulk action finishes.');
        return true;
      }

      // Bound only while a run is active. StoreCtrl scopes are never destroyed on a
      // Turbolinks visit (angular_app.js recompiles the body against $rootScope), so a
      // listener left bound would outlive the page.
      var bulkLeaveGuards = null;

      function bindBulkLeaveGuards() {
        if (bulkLeaveGuards) return;
        bulkLeaveGuards = {
          beforeunload: function (event) {
            var message = 'A bulk review is still running.';
            event.preventDefault();
            if (event.originalEvent) event.originalEvent.returnValue = message;
            return message;
          },
          beforeVisit: function (event) {
            if (confirm('A bulk review is still running. Leave this page? Rows not sent yet will be skipped.')) {
              cancelBulkRun();
            } else {
              event.preventDefault();
            }
          },
          // Back/forward restoration visits cannot be cancelled and the JS context survives
          // a Turbolinks visit, so stop the queue here. Requests in flight finish server-side.
          visit: function () {
            cancelBulkRun();
          }
        };
        $(window).on('beforeunload', bulkLeaveGuards.beforeunload);
        $(document).on('turbolinks:before-visit', bulkLeaveGuards.beforeVisit);
        $(document).on('turbolinks:visit', bulkLeaveGuards.visit);
      }

      function unbindBulkLeaveGuards() {
        if (!bulkLeaveGuards) return;
        $(window).off('beforeunload', bulkLeaveGuards.beforeunload);
        $(document).off('turbolinks:before-visit', bulkLeaveGuards.beforeVisit);
        $(document).off('turbolinks:visit', bulkLeaveGuards.visit);
        bulkLeaveGuards = null;
      }

      // Leaving: send nothing more, and unbind now so the next page never sees these guards.
      function cancelBulkRun() {
        $scope.bulk.cancelled = true;
        unbindBulkLeaveGuards();
      }

      $scope.dataTable = function() {
        if ($scope.data_table) return;
        $scope.data_table = $('.dataTable').DataTable({
          columnDefs: [
            // Column 0 is the bulk checkbox; Score (3) and Action (5) stay sortable.
            { orderable: false, targets: [0,1,2,4] },
          ],
          order: [],
          paging: false,
          searching: false,
          info: false,
          retrieve: true
        });
      }

      $scope.undoReview = function(product) {
        if ($scope.select_type_product != 'review') return;
        // Undo recounts connected_products too; mid-run it races the held final approval.
        if (bulkBusy()) return;
        // undo_review_store_product returns no data, so the counter decision is made from
        // the row's state before the request: only undoing an approval removes a mapping.
        var was_approved = !product.is_review && !product.is_rejected;

        $.ajax({
          // beforeSend: function(){
          //   $(".loading").hide();
          //   $(".loading").attr('style', 'background: rgba(0, 0, 0, 0)');
          //   $(".loading").attr('style', 'z-index: -1 !important');
          // },
          url: $scope.undo_review_url,
          dataType: "json",
          cache: false,
          type: "POST",
          data: { product_id: product.id, box_id: product.box_id, is_admin: $scope.is_admin, store_slug: $scope.store_slug },
          success: function (rs) {
            $timeout(function () {
              if (rs.succeed) {
                product.is_review = true;
                product.is_rejected = false;
                if (was_approved) {
                  $scope.connected_products -= 1;
                }
                // Back in the review list, so it no longer shifts the next page.
                if (product.bulk_moved) {
                  product.bulk_moved = false;
                  if ($scope.bulk.changed > 0) $scope.bulk.changed -= 1;
                }
                toastr.success(rs.message);
              } else {
                toastr.error(rs.message);
              }
            });
          },
          error: function(err) {
            $timeout(function () {
              toastr.error("An Unexpected Error Occurred!");
            });
          }
        });
      }

      $scope.searchBoxes = function() {
        if (bulkBusy()) return;
        if ($scope.select_type_product == "mapping") {
          $scope.searchMapping($scope.key_search);
        } else {
          $scope.getDataProduct($scope.key_search);
        }
      };

      $scope.handleEnter = function($event) {
        $event.preventDefault();
        $scope.searchBoxes();
      };

      // The "Needs mapping" count (tab pill and KPI tile). The page-load call passes nothing.
      // A re-read after a not-sealed change passes {silent: true}: nobody asked for it, so it
      // stays off the layouts' full-screen overlay (fe.rules.md FE-1) and never toasts an error;
      // if it fails the badge simply stays as it was. The newest read wins, so a slow earlier
      // answer cannot overwrite a later one.
      var notificationNumberReads = 0;

      $scope.fetchNotificationNumber = function(opts) {
        opts = opts || {};
        var read = ++notificationNumberReads;
        $.ajax({
          url: $scope.notification_number_url,
          dataType: "json",
          cache: false,
          type: "GET",
          global: !opts.silent,
          success: function (rs) {
            $timeout(function () {
              if (read != notificationNumberReads) return;
              if (rs.succeed) {
                $scope.notification_number = rs.data;
              } else if (!opts.silent) {
                toastr.error(rs.message);
              }
            });
          }
        });
      }
    }
  ]);

  // ENG-331: "some rows selected" is the checkbox's indeterminate DOM property, which no
  // attribute and no ng-* directive can set. Namespaced: pages/ files ship on every page.
  app.directive('storeBulkIndeterminate', function () {
    return function (scope, element, attrs) {
      scope.$watch(attrs.storeBulkIndeterminate, function (value) {
        element.prop('indeterminate', !!value);
      });
    };
  });

}).call(this);